import React, { Component } from 'react';
import LearnList from './LearnList';
import CourseCard from './CurriculumCourseCard';

export default class LearnCoursesList extends Component {
  renderCard(props, index) {
    return <CourseCard {...props} key={index} />;
  }

  render() {
    return <LearnList {...this.props} renderCard={this.renderCard} />;
  }
}
